export default "__VITE_ASSET__09c7d371__"